import { ButtonBase, styled } from '@mui/material';

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(3),
  border: `1px solid ${theme.palette.divider[7]}`,
  '& .BCContainer': {
    width: '100%',
    height: '100%',
  },
  '& .BCImgContainer': {
    height: theme.typography.pxToRem(300),
    width: '100%',
    borderRadius: theme.spacing(3),
    overflow: 'hidden',
    flex: ' 0 0 auto',
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(221),
    },
     '& .IBimg': {
        transition: 'transform 0.4s ease-in-out',
      },
  },
  '& .BCDetailsContainer': {
    width: '100%',
    height: '100%',
    padding: theme.spacing(3, 2),
    display: 'flex',
    flexDirection: 'column',
  },
  '& .BCTitle': {
    wordBreak: 'break-word',
  },
  '& .BCMaxText': {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .BCDateContainer': {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(4),
  },
  '& .BCDateIcon': {
    fontSize: theme.spacing(2.5),
    position: 'relative',
    top: theme.typography.pxToRem(-1),
    color: theme.palette.text.secondary,
  },
  '& .BCDateText': {
    fontSize: theme.spacing(1.75),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  '&.BCStrachedCard': {
    '& .BCContainer': {
      flexDirection: 'row',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    '& .BCImgContainer': {
      minHeight: theme.typography.pxToRem(350),
      height: '100%',
      width: `calc(50% - ${theme.spacing(2)})`,
      [theme.breakpoints.down('md')]: {
        height: theme.typography.pxToRem(221),
        minHeight: theme.typography.pxToRem(221),
        width: '100%',
      },
     
    },
    '& .BCDetailsContainer': {
      padding: theme.spacing(4),
      [theme.breakpoints.down('lg')]: {
        padding: theme.spacing(3, 2),
      },
    },
    '& .BCTitle': {
      [theme.breakpoints.up('md')]: {
        fontSize: theme.spacing(3),
      },
    },
  },
  '&:hover': {
    '& .IBimg': {
      transform: 'scale(1.05)',
    },
  },
}));

export default StyledButtonBase;
